import * as actionTypes from '../../types/header';
import * as actionTypesGeneral from '../../types/general';
import { getNavbarConfig, getNavbarCounters } from '../../../services/endpoints/general';

/**
 * @function
 * @name getNavbarConfigAction
 * @description Конфигурация навбара
 */
export const getNavbarConfigAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET_NAVBAR });

  try {
    const response = await getNavbarConfig();
    const { data } = response;

    dispatch({
      type: actionTypes.GET_NAVBAR_SUCCESS,
      data,
      menu: data.menu,
    });

    dispatch({
      type: actionTypesGeneral.CHANGE_VIEW_MODE_SUCCESS,
      payload: data.dark_mode,
    });
  } catch (error) {
    dispatch({ type: actionTypes.GET_NAVBAR_ERROR, error });
  }
};

/**
 * @function
 * @name getNavbarConfigSuccessAction
 */
export const getNavbarConfigSuccessAction = (data) => async (dispatch) => {
  dispatch({
    type: actionTypes.GET_NAVBAR_SUCCESS,
    data,
    menu: data.menu,
  });
  dispatch({
    type: actionTypesGeneral.CHANGE_VIEW_MODE_SUCCESS,
    payload: data.dark_mode,
  });
};

export const getNavbarConfigErrorAction = (error) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_NAVBAR_ERROR, payload: { error } });
};

/**
 * @function
 * @name getNavbarCountersAction
 */
export const getNavbarCountersAction = (params) => async (dispatch) => {
  try {
    const response = await getNavbarCounters(params);
    const { data } = response;

    dispatch({
      type: actionTypes.GET_NAVBAR_COUNTERS_SUCCESS,
      data,
    });
  } catch (error) {
    console.log(error);
  }
};
